import { FC } from "react";

import Slider from "../../components/Slider/SliderANTD";

import "./About.css";

const About: FC = () => {

  return (
    <>

      <div className="full-width-slider-container">
        <Slider />
      </div>

      <div className="container about">


        <div className="short-width-slider-container">
          <Slider />
        </div>

        <div className="about-info">

          <h1>РЕКЛАМНО-ПРОИЗВОДСТВЕННАЯ КОМПАНИЯ «АБСОЛЮТ&nbsp;МЕДИА»</h1>
          <h2 className="about-text red mb25">РАБОТАЕТ В КРАСНОДАРЕ С 2008 ГОДА, И ЯВЛЯЕТСЯ РЕКЛАМНЫМ АГЕНТСТВОМ ПОЛНОГО ЦИКЛА.</h2>
          {/*<p>Сувенирная продукция - это эмоции.</p>*/}
          {/*<p className="about-text red mb25">*/}
          {/*  Всем приятно получать подарки, пусть и самые незначительные.*/}
          {/*</p>*/}
          {/*<p className="about-text">*/}
          {/*  Рекламное агентство «Абсолют Медиа» с 2008 года работает на рынке промопродукции и бизнес-подарков.*/}
          {/*</p>*/}
          <p className="about-text mb25">
            Производственные площади с современным оборудованием позволяют нам предлагать несколько видов печати: офсетная, флексопечать, цифровая, широкоформатная, интерьерная, УФ-печать, ДТФ-печать, шелкография, сублимация. Также мы специализируемся на изготовлении и монтаже всех видов наружной рекламы и вывесок.
          </p>
          <p className="about-text mb25">
            У нас всегда широкий выбор сувенирной продукции. Компания работает только с проверенными брендами. Мы постоянно разрабатываем и создаем принципиально новые промопродукты и бизнес-подарки, поэтому всегда готовы отойти от стандартных схем и предложить заказчикам самые интересные и нестандартные варианты. А затем воплотить их в жизнь на высшем уровне. Для этого у агентства есть своя дизайн-студия и широкие производственные мощности. Выбор технологий производства и методов нанесения практически безграничен. Результат такой работы — уникальные решения для продвижения компаний.
          </p>
          <h2 className="mb25">
            СФЕРЫ НАШЕЙ КОМПЕТЕНЦИИ:
          </h2>
          <ul>
            <li className='my-list'>Изготовление полиграфической продукции</li>
            <li className='my-list'>Изготовление наружной рекламы и вывесок</li>
            <li className='my-list'>Изготовление сувенирной продукции</li>
            <li className='my-list'>Широкоформатная и интерьерная печать</li>
            <li className='my-list'>Разработка дизайна полиграфической, сувенирной продукции и наружной рекламы</li>
            <li className='my-list'>Регистрация товарного знака</li>
          </ul>

        </div>

      </div>
    </>
  );
};

export default About;
